const PageSearchBar = () => {
  //check if page matches one of the following
  if (document.querySelector('.page.page-id-240') || document.querySelector('.product-template-default.single-product')) {
    const searchContainer = document.querySelector('[data-widget="search-product"]');
    let selectedProduct = null;

    //get selected product from dropdown
    const dropdown = document.querySelector('.dropdown-toggle span strong');
    if (dropdown) {
      selectedProduct = dropdown.innerHTML.toLowerCase();
    }


    /*
     Event Listeners
    */

    //dropdown item selected
    document.querySelectorAll('ul.dropdown-menu li').forEach(el => {
      el.addEventListener('click', function () {
        //get data-option value and set as selectedProduct
        selectedProduct = el.getAttribute('data-option').toLowerCase();
        //set dropdown button text
        document.querySelector('.dropdown-toggle span').innerHTML = el.innerHTML;
        //hide error message
        searchContainer.querySelector('.dropdown .text-danger').style.display = "none";
      });
    });

    //search button pressed
    document.querySelector('#search-button').addEventListener('click', () => searchButton());

    //keyword input enter pressed
    document.querySelector('#keyword-input').addEventListener('keypress', e => {
      //hide error message
      if (searchContainer.querySelector('.input-group p'))
        searchContainer.querySelector('.input-group p').remove();

      //search if enter key pressed
      if (e.key === 'Enter') {
        e.preventDefault();
        searchButton();
      }
    });

    /*
   Functions
    */

    function searchButton() {
      //navigate to search results page with query string
      const keywordBox = document.querySelector(`#keyword-input`);

      //commma separated keywords to |
      let keywords = keywordBox.value.split(',').join('|');
      //remove spaces before and after |
      keywords = keywords.replace(/\s*\|\s*/g, '|');
      //trim trailing spaces
      keywords = keywords.replace(/\s+$/, '');

      //add to query string
      const queryString = `?p=${selectedProduct}&k=${keywords}`;

      //encode query string
      const encodedQueryString = encodeURI(queryString);

      //error message handling
      if (searchContainer.querySelector('.input-group p'))
        searchContainer.querySelector('.input-group p').remove();

      if (keywordBox.value === "") {
        //show error message
        const errorText = document.createElement('p');
        errorText.setAttribute('style', 'font-size: 13px; font-weight: 500; font-style: italic; color: #DB0000; position: absolute; margin-left: 160px; margin-top: -36px;');
        errorText.innerHTML = "field required";
        searchContainer.querySelector('.input-group').appendChild(errorText);
      } else {
        //remove error message if exists
        if (searchContainer.querySelector('.input-group p'))
          searchContainer.querySelector('.input-group p').remove();
      }

      if (selectedProduct === null) {
        //show error message
        searchContainer.querySelector('.dropdown .text-danger').style.display = "inline-block";
      } else {
        //hide error message
        searchContainer.querySelector('.dropdown .text-danger').style.display = "none";
      }

      if (keywordBox.value !== "" && selectedProduct !== null) {
        //navigate to search results page
        window.location.href = `/results/${encodedQueryString}`;
      }
    }
  }
};

export default PageSearchBar;
